import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadProviderByIdFailed, loadProviderByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadProviderById(action) {
  try {
    const url = `${BACKEND_URL}/providers/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadProviderByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadProviderByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadProviderByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
